<div class="filters-container" [formGroup]="filtersForm">
  <mat-form-field *ngFor="let filter of filters">
    <mat-label>{{ filter.label }}</mat-label>

    <input matInput *ngIf="filter.type === 'text'"
           [formControlName]="filter.key"
           [placeholder]="filter.placeholder || ''">

    <mat-select *ngIf="filter.type === 'select'"
                [formControlName]="filter.key">
      <mat-option *ngFor="let option of filter.options" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <button mat-button color="primary" (click)="resetFilters()">
    Réinitialiser
  </button>
</div>
